// extracted by mini-css-extract-plugin
module.exports = {"is-mob":"contactImage_is-mob__K_Ytk","is-desk":"contactImage_is-desk__JUd74","contactImage__img":"contactImage_contactImage__img__Dp11T"};